import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Items extends Vue {
  showCategoryModal: boolean = false
  from: string = null

  addItem() {
    this.showCategoryModal = true
    this.from = 'new'
  }

  importItem() {
    this.showCategoryModal = true
    this.from = 'csv'
  }

  helpImportItem() {
    this.$router.push({ name: 'itemImportHelp' })
  }
}
